import { render, staticRenderFns } from "./ModalNews.vue?vue&type=template&id=42a6689f&"
import script from "./ModalNews.vue?vue&type=script&lang=js&"
export * from "./ModalNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports